import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import TextInputReferenciaFormik from "../../../../components/UI/TextInput/TextInputReferenciaFormik";
import useRetornaDataVencimento from "../hooks/useRetornaDataVencimento";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";

const validationSchema = Yup.object().shape({
  sqAcaoFiscal: Yup.string().default(""),
  sqItemOcorrencia: Yup.string().default(""),
  sqItem: Yup.string().default(""),
  txReferencia: Yup.string().default(""),
  dtVencimento: Yup.string().default(""),
  vlDeclarado: Yup.string().default(""),
  vlApurado: Yup.string().default(""),
  vlIcms: Yup.string().default(""),
  vlIcmsRecolhido: Yup.string().default(""),
  dsItem: Yup.string().default(""),
  vlMultaOcorrenciaAtual: Yup.string().default(""),
  vlTotalNota: Yup.string().default(""),
  vlProduto: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const DemonstrativoP = ({ formik }) => {
  const { onBlurReferencia } = useRetornaDataVencimento({ formik });
  const { handleMoneyChange } = useAcoesDemonstrativo({ formik });

  return (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={12}>
          <span>Descrição:</span>
          <HtmlEditor formik={formik} field="dsItem" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" p as={Col} sm={12} md={4}>
          <Form.Label>Referência:</Form.Label>
          <TextInputReferenciaFormik
            formik={formik}
            field="txReferencia"
            placeholder="mm/aaaa ou dd/mm/aaaa"
            mask=""
            evento={onBlurReferencia}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Data de Vencimento:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Valor da Operação (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlOperacao"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Valor da Base de Calculo (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlBaseCalculo"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label> Alíquota (%):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlAliquota"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>ICMS a Recolher (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcmsARecolher"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            disable
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default DemonstrativoP;
